import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HttpClientModule} from "@angular/common/http";
import { SectionNavigationBasicComponent } from "./section-navigation/section-navigation-basic.component";
import { SectionNavigationElectronicComponent } from "./section-navigation/section-navigation-electronic.component";
import { RouterModule } from "@angular/router";
import { APP_BASE_HREF, TitleCasePipe } from "@angular/common";
import { FilterBarComponent } from "./filter-bar/filter-bar.component";
import { ProductVariantGridComponent } from "../../../Common/components/product-variant-grid/product-variant-grid.component";
import { CategoryBrowsingComponent } from './category-browsing/category-browsing.component';
import {ProductVariantGridCategoryBrowsingComponent} from "./product-variant-grid-category-browsing/product-variant-grid-category-browsing.component";
import { ProductsService } from "../../../Common/Services/products.service";
import { ProductCardComponent} from "../../../Common/components/product-card/product-card.component";
import { PropertiesService } from "../../../Common/Services/properties.service";
import { ProductVariantGridCategoryBrowsingElectronicComponent } from "./product-variant-grid-category-browsing/product-variant-grid-category-browsing-electronic.component";
import { ProductCardAltComponent } from "../../../Common/components/product-card-alt/product-card-alt.component";
import { StyleCardComponent } from "../../../Common/components/style-card/style-card.component";
import TranslationsService from "../../../Common/Services/translations.service";

@NgModule({
  declarations: [
    AppComponent,
    SectionNavigationBasicComponent,
    SectionNavigationElectronicComponent,
    FilterBarComponent,
    ProductVariantGridComponent,
    CategoryBrowsingComponent,
    ProductCardComponent,
    ProductCardAltComponent,
    StyleCardComponent,
    ProductVariantGridCategoryBrowsingComponent,
    ProductVariantGridCategoryBrowsingElectronicComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule.forRoot([
      { path: '**', component: CategoryBrowsingComponent }
    ]),
  ],
  providers: [
    ProductsService,
    TitleCasePipe,
    PropertiesService,
    TranslationsService,
    [{provide: APP_BASE_HREF, useValue: '/'}]
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/ts/Apps/CategoryBrowsing/src/app/app.module.ts